import {getEnv} from '../../common/env/env';
import {ItemSingleDto} from '../../common/shared/api/gateway/ItemSingleDto.interface';
import {LandingPageVo} from '../../common/shared/api/karina/vo/page/LandingPageVo.interface';
import {getKageUrl} from '../../common/shared/utils/getKageUrl';
import {
  ContentsType,
  Maybe,
  SingleListViewLandingList,
  User,
} from '../generated/types';
import {createNormalListViewItem} from './NormalListViewItem';
import {createSortOption} from './SortOption';

export function createSingleListViewLandingList(
  userInfo: Maybe<User>,
  landingPage: LandingPageVo<ItemSingleDto>,
  id: string,
  page: number
): SingleListViewLandingList {
  return {
    id,
    isEnd: landingPage.is_end,
    type: ContentsType.Single,
    totalCount: landingPage.total_count,
    list: landingPage.list.map(item =>
      createNormalListViewItem(userInfo, {
        listViewLandingItemSingleDto: item,
      })
    ),
    themeKeywordOptList: landingPage.theme_keyword_opt_list?.map(sortOption =>
      createSortOption({filterOptionVo: sortOption})
    ),
    selectedThemeKeywordOpt: landingPage.selected_theme_keyword_opt
      ? createSortOption({
          filterOptionVo: landingPage.selected_theme_keyword_opt,
        })
      : undefined,
    title: landingPage.title,
    topImage: landingPage.top_image
      ? getKageUrl({
          kageId: landingPage.top_image,
          kageUrlPrefix: getEnv().kageUrlPrefix,
          resolution: 'o1',
        })
      : undefined,
    page,
  };
}
